var map = {
	"./CA.svg": "5d67",
	"./DE.svg": "3fd5",
	"./FR.svg": "2683",
	"./UK.svg": "d504",
	"./US.svg": "1165",
	"./close-cu.svg": "26b7",
	"./close.svg": "a2d7",
	"./dingwei.svg": "88bc",
	"./disamfang-amazon.svg": "5aac",
	"./duigou-cu.svg": "6217",
	"./duigou.svg": "1809",
	"./error-chenchong.svg": "8a1b",
	"./error.svg": "3a60",
	"./facebook.svg": "a79d",
	"./home.svg": "fb6e",
	"./info-chenchong.svg": "09ca",
	"./info.svg": "6dcc",
	"./instagram.svg": "3f07",
	"./jiantou-cu.svg": "0e90",
	"./jiantou-down-cu.svg": "5277",
	"./jiantou.svg": "fd30",
	"./linkedin.svg": "5dcd",
	"./menu1-cu.svg": "087b",
	"./menu1.svg": "0783",
	"./menu2-cu.svg": "50a0",
	"./menu2.svg": "ef90",
	"./pinterest.svg": "29ee",
	"./red.svg": "b6f0",
	"./shangjia.svg": "3988",
	"./shezhi.svg": "de3b",
	"./success-chenchong.svg": "e598",
	"./success.svg": "1b27",
	"./tiktok.svg": "de76",
	"./tuichu.svg": "0951",
	"./warring-chenchong.svg": "796b",
	"./warring.svg": "01ec",
	"./wechat.svg": "0382",
	"./weibo.svg": "97d5",
	"./wenjing-bi.svg": "43f8",
	"./wenjing-kai.svg": "f53a",
	"./wodi1.svg": "9f7d",
	"./wodi1beifen2.svg": "51ef",
	"./wodi2.svg": "865c",
	"./wodi3.svg": "49ee",
	"./wodi4.svg": "c561",
	"./x.svg": "4a8a",
	"./youjian.svg": "4071",
	"./youtube.svg": "2931"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0780";